/*
License

Copyright (c) 2022 Chukwubuikem Ume-Ugwa

Permission is hereby witheld, any person obtaining a copy
of this software and associated documentation files (the "Software"), cannot
use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software. These restrictions can be only lifted with
a written permission from Chukwubuikem Ume-Ugwa.
*/
export const PUBLIC = 0,
  PRIVATE = 1, GEOFENCED = 2;
export const QueueType = {
  PUBLIC: PUBLIC,
  PRIVATE: PRIVATE,
  GEOFENCED: GEOFENCED
};
const Queue = {
  queue_address: 'queue_address',
  owner_wallet_address: 'owner_wallet_address',
  number_of_tracks: 'number_of_tracks',
  number_of_hours: 'number_of_hours',
  art_uri: 'art_uri',
  name: 'name',
  type: 'type',
  created_on: 'created_on',
  subscription: 'subscription',
  collabs: 'collabs',
  locked: 'locked',
  radius: 'radius',
  geo_reference: 'geo_eference',
};

const Subscription = {
  schedule: 'schedule',
  price: 'price',
};

const FILE = 0,
  LINK = 1;
const TrackType = [FILE, LINK];
const Track = {
  queue_address: 'queue_address',
  owner_wallet_address: 'owner_wallet_address',
  track_uri: 'track_uri',
  art_uri: 'art_uri',
  pricing_unit: 'pricing_unit',
  price: 'price',
  title: 'title',
  artist: 'artist',
  duration: 'duration',
  track_address: 'track_address',
  type: 'type',
  created_on: 'created_on',
  loops: 'loops',
};

const Wallet = {
  wallet_address: 'wallet_address',
};

const Token = {
  token_address: 'token_address',
  authority_address: 'authority_address',
  supply: 'supply',
};

const DbNode = {
  queues: 'queues',
  tracks: 'tracks',
  shards: 'shards',
  count: 'count',
  token: 'token',
  deleted_queues: 'deleted_queues',
  subscriptions: 'subscriptions',
  subscribers: 'subscribers',
  monthly_subscribers: 'monthly_subs',
  monthly_streams: 'monthly_streams',
  monthly_grossing: 'monthly_grossing',
  monthly: 'monthly',
  stats: 'stats',
};

const Stats = {
  streams: 'streams',
  subscribers: 'subscribers',
  grossing: 'grossing',
  number_of_tracks: 'number_of_tracks',
  number_of_hours: 'number_of_hours',
  collabs: 'collabs',
};

const StorageNode = {
  tracks: 'tracks',
  artworks: 'artworks',
};

const queue_art_size = {
  small: { height: 100, width: 100 },
  medium: { height: 100, width: 320 },
};

const track_art_size = {
  small: { height: 100, width: 100 },
};

const Schemas = {
  track_schema: Track,
  queue_schema: Queue,
  user_schema: Wallet,
  db_node_schema: DbNode,
  storage_schema: StorageNode,
  token_schema: Token,
  subscription_schema: Subscription,
  stats_schema: Stats,
};

const LOOPS = 0;
const SECONDS = 1;
const SCHEDULE_MT = 0;
const SCHEDULE_YR = 1;

export const Constraints = {
  sizes: [queue_art_size, track_art_size],
  shards: 10,
  pageSizes: { queue: 100, track: 100 },
  pricingUnit: [LOOPS, SECONDS],
  schedule: [SCHEDULE_MT, SCHEDULE_YR],
  trackType: TrackType,
  queueType: QueueType,
};

export default Schemas;
